import { render } from "./EditKinkekaart.vue?vue&type=template&id=307a9647&scoped=true"
import script from "./EditKinkekaart.vue?vue&type=script&lang=js"
export * from "./EditKinkekaart.vue?vue&type=script&lang=js"

import "./EditKinkekaart.vue?vue&type=style&index=0&id=307a9647&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307a9647"]])

export default __exports__